import React from "react";

export default function StorageVariantsEditor({ rows, onChange, basePrice }) {
  const updateRow = (index, patch) => {
    const next = rows.map((row, i) => (i === index ? { ...row, ...patch } : row));
    onChange(next);
  };

  const addRow = () => onChange([...(rows || []), { storage: "", price: "0" }]);

  const removeRow = (index) => {
    const next = (rows || []).filter((_, i) => i !== index);
    onChange(next.length ? next : [{ storage: "", price: "0" }]);
  };

  return (
    <div className="storage-rows-editor">
      <table className="admin-table compact-editor-table">
        <thead>
          <tr>
            <th>Storage (GB)</th>
            <th>Base price (₹)</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {(rows || []).map((row, index) => (
            <tr key={index}>
              <td>
                <input
                  value={row.storage}
                  placeholder="128"
                  onChange={(e) => updateRow(index, { storage: e.target.value.replace(/[^\dA-Za-z+\s]/g, "") })}
                />
              </td>
              <td>
                <input
                  type="number"
                  value={row.price}
                  placeholder={basePrice ? String(basePrice) : "0"}
                  onChange={(e) => updateRow(index, { price: e.target.value })}
                />
              </td>
              <td className="actions-cell">
                <button type="button" className="admin-btn secondary" onClick={() => removeRow(index)}>
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button type="button" className="admin-btn secondary" onClick={addRow} style={{ marginTop: 8 }}>
        + Add variant
      </button>
      <p className="field-hint">
        Base price in ₹ for each variant — shown to customers in the app before Q&amp;A.
        Use 0 to inherit the model base price
        {basePrice ? ` (₹${basePrice})` : ""}.
      </p>
    </div>
  );
}
